import { useEffect, useState } from 'react';
import { getCashBalance } from '../services';
import { CashBox, ICashBalanceData, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useCashBalance(
	branch: string | undefined,
	box: CashBox = 'CHICA',
): HookState<ICashBalanceData> & { refetch: () => void } {
	const [state, setState] = useState<HookState<ICashBalanceData>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});
	const [tick, setTick] = useState(0);

	useEffect(() => {
		if (!branch) {
			setState({ data: null, loading: false, error: null, cachedAt: null });
			return;
		}

		let cancelled = false;
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getCashBalance(branch, box)
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled) setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
		};
	}, [branch, box, tick]);

	return { ...state, refetch: () => setTick((t) => t + 1) };
}
